import { CSSProperties } from 'react'

export const getTooltipPositionStyles = (menuRect: DOMRect, buttonRect: DOMRect, containerRect: DOMRect) => {
  let styles: CSSProperties = {}
  const bodyRect = document.body.getBoundingClientRect()

  const doesFitLeft = buttonRect.right - menuRect.width > 0
  const doesFitRight = buttonRect.right + menuRect.width < containerRect.right
  if (!doesFitLeft) {
    styles.left = menuRect.width / 2
  } else if (!doesFitRight) {
    styles.left = containerRect.right - menuRect.width / 2
  } else {
    styles.left = buttonRect.left + buttonRect.width / 2
  }
  styles = { ...styles, opacity: 1, top: buttonRect.top - menuRect.height - bodyRect.top }

  return styles
}
